import { render, staticRenderFns } from "./candidateNeutralList.vue?vue&type=template&id=bfc3c856&scoped=true&"
import script from "./candidateNeutralList.vue?vue&type=script&lang=js&"
export * from "./candidateNeutralList.vue?vue&type=script&lang=js&"
import style0 from "./candidateNeutralList.vue?vue&type=style&index=0&id=bfc3c856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc3c856",
  null
  
)

export default component.exports